// components/CTA/CTA.js
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

const CTA = ({ primary, children, href, pageId, className = '', ...props }) => {
  // Handle different ways of passing data
  const linkText = primary?.label || children;
  const linkHref = primary?.href || href;

  if (!linkText || !linkHref) {
    return null;
  }

  // Determine if it's an internal or external link
  const isExternal = linkHref && linkHref.startsWith && (linkHref.startsWith('http') || linkHref.startsWith('//'));

  if (isExternal) {
    return (
      <a
        href={linkHref}
        className={`base-link ${className}`}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      >
        {linkText}
      </a>
    );
  }

  return (
    <Link href={linkHref} className={`base-link ${className}`} {...props}>
      {linkText}
    </Link>
  );
};

CTA.propTypes = {
  primary: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string,
  }),
  children: PropTypes.node,
  href: PropTypes.string,
  pageId: PropTypes.string,
  className: PropTypes.string,
};

export default CTA;